(function () {

  function getProductType() {
    const btn = document.querySelector('[aria-controls*="popover-variant-dropdown"][aria-expanded]');
    const selected = document.querySelector('[id*="-1-selected-value"]');

    return selected ? selected.textContent.trim().toLowerCase() : "";
  }

  function getFrameField() {
    return [...document.querySelectorAll(".variant-picker__option")].find(el => {
      const legend = el.querySelector("legend");
      return legend && legend.textContent.toLowerCase().includes("frame");
    });
  }

  function toggleFrame() {

    const frameField = getFrameField();
    if (!frameField) return;

    const type = getProductType();

    const hide =
      type.includes("canvas print") ||
      type.includes("lustre paper print");

    frameField.style.display = hide ? "none" : "";
  }

  // Initial
  window.addEventListener("load", () => {
    setTimeout(toggleFrame, 300);
  });

  // Every click (dropdown changes)
  document.addEventListener("click", () => {
    setTimeout(toggleFrame, 150);
  });

  // Every change
  document.addEventListener("change", () => {
    setTimeout(toggleFrame, 150);
  });

  // Theme redraws the picker
  new MutationObserver(() => {
    toggleFrame();
  }).observe(document.body, {
    subtree: true,
    childList: true,
    characterData: true
  });

})();